const baseUrl = '/laskuri/api/calculation'

function getUrl(type, path) {
  if('house' === type || 'room' === type) {
    return `${baseUrl}/${type}` + (path ? ('/' + path) : '')
  }
}

function parseJSON(response) {
  return response.json()
}


function getUUID() {
  return fetch('/laskuri/localapi/uuid').then(response => response.text())
}

function getCalculationInitParams(type, calculationId) {
  return fetch(getUrl(type, `${calculationId}/initParam`)).then(parseJSON)
}

function getCalculationResult(type, calculationId) {
  return fetch(getUrl(type, `${calculationId}/result`)).then(parseJSON)
}

function getCalculation(type, calcId) {
  return fetch(getUrl(type, calcId)).then(parseJSON)
}

function updateCalculation(type, calcId, calculation) {
  return fetch(getUrl(type, calcId), {
    method: 'PUT',
    body: JSON.stringify(calculation),
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  }).then(parseJSON)
}




export default {
  getCalculationInitParams,
  getCalculationResult,

  getCalculation,
  updateCalculation,
  getUUID
}



// WEBPACK FOOTER //
// ./src/api/calculationService.js